import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions, selectors } from '../../../../entities/rates';
import { resetError } from '../../../../entities/providers';
import { Form } from '../../../element';

type FormRefType = React.RefObject<InstanceType<typeof Form>>;

let providerFormRef: FormRefType = { current: null };

export const registerProviderFormRef = (ref: FormRefType) => {
  providerFormRef = ref;
};

export const validateField = (field: string) => {
  setTimeout(() => {
    if (typeof providerFormRef.current?.validateField === 'function') {
      try {
        providerFormRef.current.validateField(field);
        // eslint-disable-next-line no-empty
      } catch (e) {}
    }
  }, 100);
};

export const useProviderForm = (key: string, type?: 'sender' | 'receiver') => {
  const isSender = type === 'sender';
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChange = useCallback((value: any) => {
    const actionCreator = isSender ? actions.setSender : actions.setReceiver;

    dispatch(actionCreator({ [key]: value }));

    // hide API error
    dispatch(resetError({ key: `${type || 'receiver'}_${key}` }));

    // show validation errors
    validateField(`${type}_${key}`);
  }, []);

  // @ts-ignore
  const form = useSelector(isSender ? selectors.getSender : selectors.getReceiver);
  // @ts-ignore
  const value: string = form[key];

  return { value, onChange, validateField };
};
